import { combineReducers } from 'redux';

import { PROGRESS_DID_CANCEL } from 'lib/popsss/progress/actions';
import {
  RECIPIENTS_MODAL_OPEN,
  RECIPIENTS_MODAL_CANCEL,
  RECIPIENT_TICK,
  RECIPIENT_UNTICK,
  RECIPIENTS_UNTICK_ALL,
  RECIPIENTS_SEND_SUBMIT,
  RECIPIENTS_SEND_SUCCESS,
  RECIPIENT_SEND_SUCCESS,
  RECIPIENTS_SEND_FAIL,
  RECIPIENTS_STATE_FETCH,
  RECIPIENTS_STATE_SUCCESS,
  RECIPIENTS_STATE_FAIL,
  CONTRACT_SECTIONS_FETCH,
  CONTRACT_SECTIONS_SUCCESS,
  CONTRACT_SECTIONS_FAIL,
} from '../actions';
import { createReducer } from '@reduxjs/toolkit';

export function isContractsModalOpen(state = false, action) {
  switch (action.type) {
    case RECIPIENTS_MODAL_OPEN:
      return true;
    case RECIPIENTS_MODAL_CANCEL:
      return false;
    default:
      return state;
  }
}

export const recipients = createReducer({}, (builder) => {
  builder
    .addCase(RECIPIENTS_SEND_SUBMIT, (state, action) => {
      action.ticked.forEach((tick) => {
        state[tick].isSending = true;
      });

      return state;
    })
    .addCase(RECIPIENT_SEND_SUCCESS, (state, action) => ({
      ...state,
      ...action.recipients,
    }))
    .addCase(RECIPIENTS_SEND_SUCCESS, (state, action) => ({
      ...state,
      ...action.recipients,
    }))
    .addCase(RECIPIENTS_STATE_SUCCESS, (state, action) => ({
      ...state,
      ...action.recipients,
    }))
    .addCase(RECIPIENTS_MODAL_CANCEL, (state, action) => ({}))
    .addCase(PROGRESS_DID_CANCEL, (state, action) => {
      Object.keys(state).forEach((k) => {
        state[k].isSending = false;
      });
      return state;
    });
});

export function isFetching(state = false, action) {
  switch (action.type) {
    case RECIPIENTS_STATE_FETCH:
      return true;
    case PROGRESS_DID_CANCEL:
    case RECIPIENTS_STATE_SUCCESS:
    case RECIPIENTS_STATE_FAIL:
      return false;
    default:
      return state;
  }
}

export function isSending(state = false, action) {
  switch (action.type) {
    case RECIPIENTS_SEND_SUBMIT:
      return true;
    case PROGRESS_DID_CANCEL:
    case RECIPIENTS_SEND_SUCCESS:
    case RECIPIENTS_SEND_FAIL:
      return false;
    default:
      return state;
  }
}

export function recipientsTicked(state = [], action) {
  switch (action.type) {
    case RECIPIENT_TICK: {
      const newState = new Set(state.values());
      action.ids.forEach((id) => newState.add(id));
      return [...newState];
    }
    case RECIPIENT_UNTICK: {
      const newState = new Set(state);
      newState.delete(action.ids[0]);
      return [...newState];
    }
    case RECIPIENTS_UNTICK_ALL:
    case RECIPIENTS_MODAL_CANCEL:
      return [];
    default:
      return state;
  }
}

export function errorMessage(state = null, action) {
  switch (action.type) {
    case RECIPIENTS_MODAL_CANCEL:
      return null;
    case RECIPIENTS_SEND_SUCCESS:
    case RECIPIENTS_STATE_SUCCESS:
      return null;
    case RECIPIENTS_SEND_FAIL:
    case RECIPIENTS_STATE_FAIL:
      return action.error;
    default:
      return state;
  }
}

/*
  Return boolean representing if there is a valid profile selected to send contracts to
  and we are not in the process to send a contract already to any of the recipients
*/
export const canSendContracts = (state) =>
  Object.entries(state.recipients).reduce((reduction, pair) => {
    const value = pair[1];
    return (reduction || value.can_send) && !value.isSending;
  }, false) && state.recipientsTicked.length > 0;

export function isFetchingContractSections(state = false, action) {
  switch (action.type) {
    case CONTRACT_SECTIONS_FETCH:
      return true;
    case CONTRACT_SECTIONS_SUCCESS:
    case CONTRACT_SECTIONS_FAIL:
      return false;
    default:
      return state;
  }
}

export function contractSections(state = [], action) {
  switch (action.type) {
    case CONTRACT_SECTIONS_SUCCESS:
      return action.contractSections;
    case CONTRACT_SECTIONS_FAIL:
      return action.error;
    default:
      return state;
  }
}

const contractsReducer = combineReducers({
  isContractsModalOpen,
  recipients,
  isFetching,
  isSending,
  recipientsTicked,
  errorMessage,
  contractSections,
  isFetchingContractSections,
});

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default contractsReducer;
